// extracted by mini-css-extract-plugin
export default {"loginArea":"login_loginArea__PVasg","inputArea":"login_inputArea__77xzl","inputField":"login_inputField__GpIJG","invalid":"login_invalid__5JS3f"};